import { render } from "./ProjectUserPledges.vue?vue&type=template&id=43dfeaf6"
import script from "./ProjectUserPledges.vue?vue&type=script&lang=js"
export * from "./ProjectUserPledges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__